import { Button, Card, Form, Input, Typography, App } from "antd";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { adminLogin } from "../api/auth";
import { setSession } from "../auth/store";

export function LoginPage() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const mutation = useMutation({
    mutationFn: adminLogin,
    onSuccess: (data) => {
      setSession(data.token, { username: data.username, displayName: data.displayName });
      message.success("登录成功");
      navigate("/");
    },
    onError: (err: Error) => {
      message.error(err.message);
    },
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
      }}
    >
      <Card style={{ width: 360 }}>
        <Typography.Title level={4} style={{ marginBottom: 16 }}>
          Glow Price 管理后台
        </Typography.Title>
        <Form
          layout="vertical"
          onFinish={(values) => mutation.mutate(values as { username: string; password: string })}
        >
          <Form.Item name="username" label="用户名" rules={[{ required: true }]}>
            <Input autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true }]}>
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={mutation.isPending} block>
            登录
          </Button>
        </Form>
      </Card>
    </div>
  );
}
